import { render, staticRenderFns } from "./ThreeDWalk.vue?vue&type=template&id=958d9a24&scoped=true&"
import script from "./ThreeDWalk.vue?vue&type=script&lang=js&"
export * from "./ThreeDWalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958d9a24",
  null
  
)

export default component.exports